import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const EditBoardContainer = React.lazy(() => import("@mediaspace/features/board-messages"));

// ds component inside no-ds page
export const render = getStandaloneComponentRenderer(EditBoardContainer, true);
